export default "__VITE_ASSET__D8_sfu9J__"